import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import {
  Table, TableRow, TableCell, TableHead, TableBody,
} from '@mui/material';
import { useEffectAsync } from '../reactHelper';
import usePositionAttributes from '../common/attributes/usePositionAttributes';
import { formatDistance, formatSpeed } from '../common/util/formatter';
import { useAttributePreference } from '../common/util/preferences';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import CollectionFab from './components/CollectionFab';
import CollectionActions from './components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import SearchHeader, { filterByKeyword } from './components/SearchHeader';
import useSettingsStyles from './common/useSettingsStyles';
import DataTable from '../common/components/Datatable';

const CostsPage = () => {
  const { classes } = useSettingsStyles();
  const t = useTranslation();
  const devices = useSelector((state) => state.devices.items);

  const [timestamp, setTimestamp] = useState(Date.now());
  const [items, setItems] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetch("/api/costs");
      if (response.ok) {
        const data = await response.json();
        setItems(data);
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 80, disableColumnMenu: true },
    {
      field: 'deviceId',
      headerName: t('sharedDevice'),
      width: 120,
      disableColumnMenu: true,
      renderCell: (params) => devices[params.row.deviceId]?.name || params.row.deviceId
    },
    { field: 'name', headerName: t('sharedName'), flex: 1,  disableColumnMenu: true },
    { field: 'type', headerName: t('sharedType'), flex: 1,  disableColumnMenu: true },
    {
      field: 'eventTime',
      headerName: t('costDate'),
      flex: 1,
      disableColumnMenu: true,
      renderCell: (params) => dayjs(params.row.eventTime).format('DD/MM/YYYY')
    },
    { field: 'price', headerName: t('sharedPrice'), flex: 1,  disableColumnMenu: true },
    {
      field: 'actions',
      headerName: t('actions'),
      sortable: false,
      renderCell: (params) => (
        <div>
          <CollectionActions
            itemId={params.row.id}
            editPath="/settings/cost"
            endpoint="costs"
            setTimestamp={setTimestamp} />
        </div>
      ),
      width: 150,
      disableColumnMenu: true,
    }
  ];

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={['userAdmin', 'sharedCosts']}>
      <DataTable
        tableName='costs'
        columns={columns}
        rows={items}
        loading={loading}
      />
      <CollectionFab editPath="/settings/cost" />
    </PageLayout>
  );
};

export default CostsPage;